Pegasus.ViewOptionsView = Em.View.extend({
  classNames: ['view-options'],
  templateName: 'controls/view_options',
  contentView: Em.ContainerView.extend({
    classNames: ['view-options-buttons'],
    childViews: ['messageActions', 'zoom'],
    cleanSlate: Em.View.extend({
      tagName: 'button',
      template: Em.Handlebars.compile('Clean Slate'),
      classNames: ['view-options-button', 'delete'],
      click: function(){
        this.get('controller').send('clearRows');
      }
    }),

    didInsertElement: function(){
      this._super();

      if ( this.get('controller.isHelpEnabled') ) {
        this.get('childViews').pushObject( this.get('help').create({
          container: this.container
        }));
      }

      if ( this.get('controller.isFeedbackEnabled') ) {
        this.get('childViews').pushObject( this.get('feedback').create({
          container: this.container
        }));
      }
    },

    messageActions: Em.View.extend({
      tagName: 'div',
      classNames: ['dropdown-container'],
      templateName: 'controls/message_actions',
      dropdownActive: false,
      click: function(){
        this.set('dropdownActive', !this.get('dropdownActive'));
      },
      actions: {
        showPreview: function(){
          this.get('controller').send('showPreview');
        }
      }
    }),

    feedback: Em.View.extend({
      tagName: 'button',
      classNames: ['view-options-button', 'feedback-button'],
      template: Em.Handlebars.compile('{{t g.feedback}}'),
      click: function(){
        this.get('controller').send('showFeedback');
      }
    }),

    help: Em.View.extend({
      tagName: 'button',
      classNames: ['view-options-button', 'help-button'],
      template: Em.Handlebars.compile('{{t g.help}}'),
      click: function(){
        this.get('controller').send('showHelp');
      }
    }),

    zoom: Em.View.extend({
      templateName: 'controls/zoom',
      contentView: Em.ContainerView.extend({
        classNames: ['vr-zoom-control'],
        childViews: ['plusButton', 'currentZoomValue', 'minusButton'],

        minusButton: Em.View.extend({
          classNames: ['vr-zoom-control-minus'],
          template: Em.Handlebars.compile('-'),
          click: function(){
            this.get('controller').decrementZoomValue(); }
        }),

        currentZoomValue: Em.View.extend({
          classNames: ['vr-zoom-current'],
          template: function(){
            return Em.Handlebars.compile( '<span>' + '{{zoomValue}}' + '%' + '</span>' );
          }.property()
        }),

        plusButton: Em.View.extend({
          classNames: ['vr-zoom-control-plus'],
          template: Em.Handlebars.compile('+'),
          click: function(){
            this.get('controller').incrementZoomValue();
          }
        })
      })
    })
  })
});
